<template>
  <div class="pcard d-flex flex-column mr-4" style="border: 1px solid #e0e0e0; border-radius: 8px; height: 100%;">
    <!-- Top Row: Status and Date -->
    <div class="d-flex justify-content-between align-items-start mb-3">
      <div class="text-break pr-2 font-weight-bold" style="font-size: 1.05rem;">
        {{ $t("audit-finding.status." + finding.status.toLowerCase()) }}
      </div>
      <div class="text-nowrap badge badge-soft-secondary font-size-13 py-1 px-2 d-flex align-items-center" style="font-weight: 500;">
        <i class="bx bx-calendar mr-1"></i> {{ $t("audit-finding.detection-date") }}: {{ finding.detectionDate | date }}
      </div>
    </div>

    <!-- Main Content: 2 Columns -->
    <div class="row mb-">
      <div class="col-md-12">
        <div class="mb-2">
          <strong>{{ $t("finding.no") }} :</strong> {{ finding.no }}
        </div>
        <div class="mb-2 text-break">
          <strong>{{ $t("audit-finding.name") }} :</strong> {{ finding.name | translate | summary }}
        </div>
        <div class="mb-2 text-break">
          <strong>{{ $t("audit-finding.description") }} :</strong> {{ finding.description | translate | summary }}
        </div>
        <div class="mb-2">
          <strong>{{ $t("audit-finding.category.text") }}:</strong> <span v-if="finding.category">{{ finding.category.name | translate }}</span>
        </div>
      </div>
      <div class="col-md-12">
        <div class="mb-2" v-if="finding.criticality">
          <strong>{{ $t("audit-finding.criticality") }} :</strong> {{ $t("finding.criticality." + finding.criticality) }}
        </div>
        <div class="mb-2" v-if="finding.control">
          <strong>{{ $t("audit-control.control.text") }} :</strong> {{ finding.control.no }}
        </div>
      </div>
    </div>

    <!-- Owner and Admin Row -->
    <div class="row mb-4">
      <div class="col-md-12 text-break mb-2">
        <strong>{{ $t("audit-finding.level") }} :</strong>
        <span v-if="finding.owner && finding.owner.organization">{{ finding.owner.organization.name }}</span>
        <span v-else-if="finding.owner && finding.owner.department">{{ finding.owner.department.name | translate }}</span>
        <span v-else-if="finding.owner && finding.owner.process">{{ finding.owner.process.name | translate }}</span>
        <span v-else>-</span>
      </div>
      <div class="col-md-12 text-break">
        <strong>{{ $t("audit-finding.admin") }}:</strong>
        <span v-if="finding.admin">{{ finding.admin.name }} </span>
        <span v-else>-</span>
      </div>
    </div>

    <!-- Button -->
    <div class="mt-auto pt-3">
      <b-button block variant="outline-primary" @click="$router.push(`/finding/detail/${finding._id}`)"">
        <strong>{{ $t("finding.management") }}</strong>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    finding: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@modules/core/compliance-item/organization-policy.scss";
</style>
